/**
 * Gets locale from the DOM (HTML lang attribute).
 * @example
 * // returns 'en-GB' (<html lang="en-GB" ...>)
 * getLocaleFromDOM()
 * @returns {string|null} - HTML lang attribute or null if somehow lang attribute is missing.
 */
const getLocaleFromDOM = () => document.documentElement.lang || null;
export default getLocaleFromDOM;
//# sourceMappingURL=getLocaleFromDOM.js.map